import { RowMenu } from '@components/RowMenu';
import { IMenu } from '@hooks/useMenu';
import { IModalWindow } from '@hooks/useModalWindow';
import { MenuItem } from '@material-ui/core';
import { IClienteEvento } from '@model/ClienteEvento';
import { EnumClienteEventoStatus } from '@model/ClienteEventoStatus';
import { EnumClienteEventoTipo } from '@model/ClienteEventoTipo';
import React from 'react';

export type EventoMenuProps = {
    menu: IMenu
    clienteEvento: IClienteEvento
    cancelarModal: IModalWindow
}

export function EventoMenu ({ clienteEvento, menu, cancelarModal }: EventoMenuProps) {
    const options = React.useMemo(() => {
        const _options: JSX.Element[] = [];

        if (clienteEvento.clienteEventoStatusId === EnumClienteEventoStatus.Registrado && clienteEvento.clienteEventoTipoId !== EnumClienteEventoTipo.Religacao && clienteEvento.clienteEventoTipoId !== EnumClienteEventoTipo.BloqueioTotal) {
            _options.push(<MenuItem key={1} onClick={menu.handleItemClick(cancelarModal.open)}>Cancelar Evento</MenuItem>)
        }

        return _options;
    }, [cancelarModal.open, clienteEvento.clienteEventoStatusId, clienteEvento.clienteEventoTipoId, menu]);

    return (
        <RowMenu menu={menu}>{ options }</RowMenu>
    )
}